<div id="SEOC" class="home-tab-container">
  <input id="tab-one" type="radio" name="grp" checked="checked" /><label for="tab-one">Overview</label>
  <div id="overview" class="home-tab-content overview">
    <div>
      <div class="ins-heading pt-10">
        <h1 class="aem-header">Car Insurance Premium Calculator Online
        </h1>
      </div>
      <div class="ins-answer pt-10">
        <p class="pt-10">Car insurance premium calculator is
          a very helpful online tool that lets you determine
          and derive the insurance premium
          quote for your car. It also enables you to compare insurance quotes offered by various insurers in India. All
          you have to do is enter a few details in the car insurance premium calculator such as your car’s make and
          model, registration number, etc. and your free quote is displayed instantly!
        </p>
        <p class="pt-10">Each of us has our own set of requirements when it comes to
          car insurance. A car insurance premium calculator helps find and select the best car insurance policy that
          meets these requirements. Moreover, this makes it easy to compare different insurance companies in India
          (including old insurers) and choose a reliable policy through a simple and time-saving process.</p>
      </div>
      <div class="">
        <h2 class="ins-heading pt-10">How to Use Online Car Insurance Premium Calculator
        </h2>
      </div>
      <div class="ins-answer pt-10 margin6">
        <p>The online car insurance premium calculator is an easy-to-use tool. All you need to do is follow some quick
          steps online, enter the relevant information and the calculator displays the premium amount payable by you.
          Just follow these 5 simple steps to calculate your car insurance premium:
        </p>
        <p><strong>1.</strong> Enter your car’s registration number, mobile number, pin code and click on ‘Calculate’.
        </p>
        <p><strong>2.</strong> Fill in your car details such as make & model, fuel type, other information and click
          ‘Calculate’.
        </p>
        <p><strong>3.</strong> Pick the plan of your choice!
        </p>
        <p><strong>4.</strong> Provide your personal information including date of birth, address, etc.
        </p>
        <p><strong>5.</strong> And that’s it! Your car insurance premium will be displayed.
        </p>
      </div>
      <div class="">
        <h2 class="ins-heading pt-10">Benefits of Using a Car Insurance Premium Calculator
        </h2>
      </div>
      <div class="ins-answer pt-10 margin6">
        <p>As <a class="link-desc" target="_blank"
            href="https://www.bajajfinservmarkets.in/insurance/car-insurance.html">car insurance</a> is mandatory in
          India, customers are becoming keen on ensuring that their car insurance policy is in place. With the entire
          car insurance premium calculation process made available online, here’s why an online car insurance calculator
          in India proves beneficial:
        </p>
        <ul>
          <li>An online car insurance premium calculator is a simple, reliable, convenient & hassle-free tool.</li>
          <li>It helps you become familiar with the options available. </li>
          <li>It saves an ample amount of time by eliminating the need of doing manual calculations.</li>
          <li>It helps you be prepared with the pre-requisite documents.</li>
          <li>Vehicle insurance calculators let you easily familiarise yourself with the nitty-gritty of various
            insurance plans, thereby allowing you to make a well-informed decision.
          </li>
          <li>The car insurance premium calculated is unbiased with no middlemen or agents involved.
          </li>
          <li>This tool offers you the convenience of use from anywhere.
          </li>
        </ul>
      </div>
      <div class="">
        <h2 class="ins-heading pt-10">How to Calculate Car Insurance Premium
        </h2>
      </div>
      <div class="ins-answer pt-10">
        <p>With the help of the car insurance premium calculation formula, you can easily understand how the premium
          rate is estimated. The components required for the calculation consist of the own damage premium, No Claim
          Bonus, other discounts, third-party liability premium, etc. Here’s how to calculate car insurance premium in
          India using car insurance premium calculator:
        </p>
      </div>
      <div class="">
        <h3 class="ins-heading pt-10"><i>Car Insurance Premium = Own Damage Premium - (No Claim Bonus + Discounts) + TP
            Liability Premium</i>
        </h3>
      </div>
      <div class="ins-answer pt-10">
        <p>Furthermore, the <a class="link-desc" target="_blank"
            href="https://www.bajajfinservmarkets.in/insurance/car-insurance/third-party-car-insurance.html">third-party
            car insurance </a>rates are decided by the IRDAI based on the engine capacity of the vehicle as follows:
        </p>
      </div>
      <table id="bagic-faq" class="table table-bordered benefit-table">
        <thead>
          <tr>
            <th class="head-width content-align-left">Engine Capacity</th>
            <th class="content-align-right">TP Premium Rates <br>(FY 2019-20)</th>
            <th class="content-align-right">Premium Rates (w.e.f. April 1, 2022)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-bold content-align-left">Not more than 1000cc</td>
            <td class="text-bold content-align-right">₹2,072</td>
            <td class="text-bold content-align-right">₹2,094</td>
          </tr>
          <tr>
            <td class="text-bold content-align-left">More than 1000cc but not exceeding 1500cc </td>
            <td class="text-bold content-align-right">₹3,221</td>
            <td class="text-bold content-align-right">₹3,416</td>
          </tr>
          <tr>
            <td class="text-bold content-align-left">More than 1500cc</td>
            <td class="text-bold content-align-right">₹7,890</td>
            <td class="text-bold content-align-right">₹7,897</td>
          </tr>
        </tbody>
      </table>
      <h2 class="ins-heading pt-10">Factors which Determine Car Insurance Premium
      </h2>
      <div class="blocks">
        <div class="d-flex-blocks">
          <div class="img-div-height">
            <span role="Vehicle Age"><img class="" width="67" height="62" alt="Vehicle Age"
                src="./assets/img/svg/Vehicle Age.svg"></span>
          </div>
          <h3 class="img-label">Vehicle Age
          </h3>
          <div class="offer-desc">The manufacturer’s present value & depreciation based on the age of your car help
            determine the car's Insured Declared Value.
            Hence, it remains a crucial factor.
          </div>
          <hr class="landing-hr">
        </div>
        <div class="d-flex-blocks">
          <div class="img-div-height">
            <span role="Geographic Location" class=""><img class="" width="67" height="62" alt="Geographic Location"
                src="./assets/img/svg/Geographic Location.svg"></span>
          </div>
          <h3 class="img-label">Geographic Location
          </h3>
          <div class="offer-desc">If you are located in areas that are prone to vandalism, you may have to pay a higher
            premium. This is because a car parked in a dangerous zone means greater chances of damage and theft.
          </div>
          <hr class="landing-hr">
        </div>
        <div class="d-flex-blocks">
          <div class="img-div-height">
            <span role="Type of Coverage"><img class="" width="67" height="62" alt="Type of Coverage"
                src="./assets/img/svg/Type of Coverage.svg"></span>
          </div>
          <h3 class="img-label">Type of Coverage
          </h3>
          <div class="offer-desc">The type of car insurance plan you opt for, third-party insurance or<a
              class="link-desc" target="_blank"
              href="https://www.bajajfinservmarkets.in/insurance/motor-insurance/car-insurance/articles/what-is-comprehensive-car-insurance.html">
              comprehensive car insurance</a>, has a key role to play in determining your car insurance premium. As
            comprehensive car insurance covers both own damage & third-party damage, the premiums are higher.
          </div>
          <hr class="landing-hr">
        </div>
        <div class="d-flex-blocks">
          <div class="img-div-height">
            <span role="Type of Engine" class=""><img class="" width="67" height="62" alt="Type of Engine"
                src="./assets/img/svg/Type of Engine.svg"></span>
          </div>
          <h3 class="img-label">Type of Engine
          </h3>
          <div class="offer-desc">Insurers often ask for your car’s engine capacity as it is one of the key factors
            determining your car insurance premium.
          </div>
          <hr class="landing-hr">
        </div>
        <div class="d-flex-blocks">
          <div class="img-div-height">
            <span role="Add-on Covers" class=""><img class="" width="67" height="62" alt="Add-on Covers"
                src="./assets/img/svg/Add-on Covers.svg"></span>
          </div>
          <h3 class="img-label">Add-on Covers
          </h3>
          <div class="offer-desc">Riders or <a class="link-desc" target="_blank"
              href="https://www.bajajfinservmarkets.in/insurance/car-insurance/add-on-covers.html">
              add-on covers</a> are a crucial factor in determining the car insurance premium amount. Although it adds
            to the base premium a bit, add-on covers are a great way to enhance your coverage with a hike of a nominal
            amount.
          </div>
          <hr class="landing-hr">
        </div>
      </div>

      <div class="">
        <h2 class="ins-heading pt-10">How to Estimate Car Insurance Premium for Old & New Cars
        </h2>
      </div>
      <div class="ins-answer pt-10 margin6">
        <p class="pt-10">To determine the premium quote for an old and a new car, you need to enter the below-mentioned
          details in the four-wheeler insurance calculator:
        </p>
        <div class="">
          <h4 class="ins-heading pt-10">Details Required to Calculate the Premium Rate for Old Car
          </h4>
        </div>
        <p class="pt-10">The car insurance premium calculator for an old or used car can be calculated by providing
          relevant car details. After entering the correct information, the online car insurance price calculator shall
          display the insurance premium amount that you need to pay for an insurance plan. The details are:
        </p>
        <ul>
          <li>Make and model of car</li>
          <li>Fuel type</li>
          <li>Depreciation rate</li>
          <li>Details of previous insurance policy</li>
          <li>Claim history</li>
          <li>Details of the previous owner, in case of second-hand car</li>
        </ul>
        <div class="">
          <h4 class="ins-heading pt-10"> Details Required to Calculate the Premium Rate for New Car
          </h4>
        </div>
        <p class="pt-10">If you choose to purchase comprehensive four-wheeler insurance for your new car, two components
          make up the premium amount. First is the third-party cover and the second is the <a class="link-desc"
            target="_blank"
            href="https://www.bajajfinservmarkets.in/insurance/car-insurance/standalone-own-damage-car-insurance.html">Own
            Damage (OD) cover</a>. As you already know, the third-party insurance rates are determined by the IRDAI.
          However, to estimate the OD premium amount, you can use the following new car insurance premium calculation
          formula:
        </p>
        <p class="pt-10"><i>OD cover = [Insured Declared Value (IDV) x insurer’s premium rate] + add on covers -
            discounts</i>
        </p>
        <p class="pt-10">You can input the below-mentioned details in the new car insurance calculator:
        </p>
        <ul>
          <li>Car manufacturer</li>
          <li>Type of car</li>
          <li>Make and model of car</li>
          <li>Fuel type</li>
          <li>Manufacturing year</li>
          <li>Registration date and state</li>
        </ul>
      </div>

      <div class="">
        <h2 class="ins-heading pt-10">List of Car Insurance Providers we are Partnered With
        </h2>
      </div>
      <div class=" mobile-divs-center ">
        <div class="">
          <h4 class="ins-heading pt-10">Bajaj Allianz Car Insurance
          </h4>
        </div>
        <div><img class="imgInsProvider1" alt="Bagic" width="210.09" height="70"
            src="./assets/img/svg/BAGIC-LOGO.svg"><img class="darkimgInsProvider" alt="Bagic"
            src="./assets/img/svg/dark-bagic-logo.svg"></div>
        <div class="ins-answer pt-10     ">Bajaj Allianz Car Insurance is a reliable product offered by Bajaj Allianz, a
          collaboration between Bajaj Finserv Limited and Allianz SE. With their profound expertise in the general
          insurance industry, their products are designed to meet the unique needs of customers. <a class="link-desc"
            target="_blank"
            href="https://www.bajajfinservmarkets.in/insurance/car-insurance/bajaj-allianz-car-insurance.html">Bajaj
            Allianz Car Insurance</a> is equipped with great features and value-added benefits, so customers can get
          better value for money.
        </div>
        <!-- <div class="verticalBar"></div> -->
        <div class=" ">
          <h4 class="ins-heading pt-10">Acko Car Insurance
          </h4>
        </div>
        <div class="mobile-divs-center ">
          <img class="img-insProvider-acko" alt="acko" width="148.33" height="50" src="./assets/img/svg/acko.svg">
        </div>
        <div class="ins-answer pt-10   bottom-40  mob-bottom-70 acko-top">Acko Car Insurance, with its different
          approach, makes buying insurance easy and quick! The <a class="link-desc" target="_blank"
            href="https://www.bajajfinservmarkets.in/insurance/car-insurance/acko-car-insurance.html">Acko Car Insurance
            plans </a>are well-designed for the customer's needs. It offers inexpensive plans and a range of add-on
          covers to enhance the plans as per customer requirements.</div>
        <div id="hdfc-ergo-section">
          <div class=" ">
            <h4 class="ins-heading pt-10">HDFC ERGO General insurance </h4>
          </div>
          <div class="mobile-divs-center "> <img class="img-insProvider-hdfc" width="76.39" height="80" alt="hdfc-ergo"
              src="./assets/img/svg/HDFC_ERGO_General_Insurance_Company.svg"> </div>
          <div class="ins-answer pt-10   bottom-40  mob-bottom-70 acko-top">With over 7100 network garages, you can
            enjoy
            cashless claims at your nearest network garage with <a class="link-desc" target="_blank"
              href="https://www.bajajfinservmarkets.in/insurance/car-insurance/hdfc-ergo-car-insurance.html">HDFC ERGO
              car
              insurance plans </a>. These plans are designed considering your requirements and budget, so you can afford
            the insurance premium. </div>
        </div>
      </div>
    </div>
  </div>
  <input id="tab-two" type="radio" name="grp" /><label for="tab-two">Comparison</label>
  <div id="comparison" class="home-tab-content vehicleComparison">
    <div>
      <div class="">
        <h2 class="ins-heading pt-10">How to Compare Car Insurance Quotes Online
        </h2>
      </div>
      <div class="ins-answer pt-10 margin6">
        <p>Buying car insurance online has made it easier for customers to
          view the premium amount payable, instantly. It is important to keep certain factors in mind, while we compare
          insurance quotes using online car insurance premium calculators. Here’s what you need to consider when <a
            class="link-desc" target="_blank"
            href="https://www.bajajfinservmarkets.in/insurance/car-insurance/guide-to-compare-car-insurance-quotes.html">comparing
            car insurance plans</a>:
        </p>
        <ul>
          <li>It is important to examine factors such as the features and inclusions to identify the right choice.</li>
          <li>Insurance cover is the next important factor that lets you select the plan. Typically, the lower the
            premium, the lower is the insurance cover. Hence, it is important to go through the plan details.</li>
          <li>Check for the add-on covers made available with the plan, so you can enhance your financial protection
            against damages.</li>
        </ul>
      </div>
      <div>
        <h2 class="ins-heading pt-10">Components of Comprehensive Car Insurance Premium
        </h2>
      </div>
      <div class="ins-answer pt-10 margin6">
        <p>Comprehensive car insurance is a well-rounded plan offering extensive coverage to your precious vehicle.
          Right from third-party cover and own damage to theft and other such perils, a comprehensive policy financially
          secures you against various risks and mishaps. So, let’s look at the key components that form the
          comprehensive car insurance premium:
        </p>
        <ul>
          <li>Third-party cover</li>
          <li>Own damage</li>
          <li>Insured Declared Value (IDV)</li>
          <li>Make and model of the car</li>
          <li>Age of the car</li>
          <li>Deductibles</li>
          <li>Personal Accident (PA) cover</li>
          <li>Add-on covers</li>
          <li>No Claim Bonus (NCB)</li>
        </ul>
      </div>
      <div class="">
        <h2 class="ins-heading pt-10">Components of Third-Party Car Insurance Premium
        </h2>
      </div>
      <div class="ins-answer pt-10 margin6">
        <p>With a third-party car insurance plan, you can opt for the most basic cover to safeguard your four-wheeler
          which is also mandated by law. The insurance policy covers any loss or damage incurred by the third party and
          includes a personal accident cover as well. Here are the components of third-party car insurance premium:
        </p>
        <ul>
          <li>Third-party cover</li>
          <li>Personal Accident (PA) cover</li>
          <li>Engine capacity or cc of the car</li>
        </ul>
      </div>
      <div class="">
        <h2 class="ins-heading pt-10">How to Reduce Car Insurance Premium
        </h2>
      </div>
      <div class="ins-answer pt-10 margin6">
        <p>Do you go for third-party car insurance while selecting
          car insurance online just to save on premiums? Not anymore! Now you need not compromise on the coverage of
          your choice. First calculate premium using third party car insurance premium calculator & reduce car insurance
          premiums by taking care of the following aspects:

        </p>
        <ul>
          <li class="bottom-10">
            <h3 class="display-inline">Compare & buy –</h3>
            <div class="top-spc-5">It is crucial to compare the car insurance plans available in order to arrive at the
              best plan that suits your needs, so you can get good value for money.</div>
          </li>
          <li class="bottom-10">
            <h3 class="display-inline">Pick Add-On Covers Wisely –</h3>
            <div class="top-spc-5">Ensure you pick the additional covers wisely, so you do not end up paying extra for
              the riders you do not require.</div>
          </li>
          <li class="bottom-10">
            <h3 class="display-inline">Avoid Filing Claims for Minor Damages –</h3>
            <div class="top-spc-5">Take care of minor damages out of your pocket, so you can save on your premium
              through the
              No Claim Bonus for every claimless policy year. </div>
          </li>
          <li class="bottom-10">
            <h3 class="display-inline">Install Anti-Theft Devices</h3>
            <div class="top-spc-5">Installing anti-theft devices approved by the Automotive Research Association of
              India (ARAI) enables you to avail a discount on premiums. Thus, it is highly recommended to take such
              safety measures to lower your car insurance price.</div>
          </li>
          <li class="bottom-10">
            <h3 class="display-inline">Avoid Modifying Vehicles</h3>
            <div class="top-spc-5">Adding new components to your car or modifying it can lead to an increase in your car
              insurance premium. To avoid paying a hefty premium, ensure to consult your insurance provider and find out
              if such modifications can lead to high premiums.</div>
          </li>
          <li class="bottom-40">
            <h3 class="display-inline">Transfer NCB</h3>
            <div class="top-spc-5">If you have earned a <a class="link-desc" target="_blank"
                href="https://www.bajajfinservmarkets.in/insurance/car-insurance/what-is-no-claim-bonus.html">No Claim
                Bonus in car insurance</a> your previous insurance plan, then it is advised to transfer it before
              switching insurers. This will allow you to reduce your car insurance premium amount and get a discount on
              renewal.</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <input id="tab-three" type="radio" name="grp" /><label for="tab-three">FAQs on Car Insurance Premium
    Calculator</label>
  <div id="faqs" class="home-tab-content vehicleFaq faqs">
    <div class="faq-details">
      <h3 #ques1 (click)="openAnswer(ques1)" class="ques">What are the components of a car insurance premium?
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="plus bi bi-plus" viewBox="0 0 16 16">
          <path
            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
        </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="minus bi bi-dash" viewBox="0 0 16 16">
          <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
        </svg>
      </h3>
      <p id="ans1" class="ans">There are three key components of a regular comprehensive car insurance premium, which
        include third-party (Liability) cover, Own Damage (OD) cover, and Personal Accident cover.</p>
    </div>
    <div class="faq-details">
      <h3 #ques2 (click)="openAnswer(ques2)" class="ques">Does a car's fuel type affect the car insurance premium?
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="plus bi bi-plus" viewBox="0 0 16 16">
          <path
            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
        </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="minus bi bi-dash" viewBox="0 0 16 16">
          <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
        </svg>
      </h3>
      <p id="ans2" class="ans">Yes, the car’s fuel type is one of the key factors affecting the car insurance premium.
        Usually, diesel cars have a relatively higher insurance premium than petrol cars as the former have a marginally
        higher risk cover than the latter.</p>
    </div>
    <div class="faq-details">
      <h3 #ques3 (click)="openAnswer(ques3)" class="ques">Does a car’s model affect the car insurance premium? <svg
          xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="plus bi bi-plus" viewBox="0 0 16 16">
          <path
            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
        </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="minus bi bi-dash" viewBox="0 0 16 16">
          <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
        </svg> </h3>
      <p id="ans3" class="ans">Yes, the car’s model is an important factor while calculating the car insurance premium.
        The premium for a third-party cover is based on the engine capacity (cc) of your car, and the make/model of your
        car also helps in determining the car’s <a class="link-desc" target="_blank"
          href="https://www.bajajfinservmarkets.in/insurance/car-insurance/what-is-idv-in-insurance.html">Insured
          Declared Value (IDV)</a> . </p>
    </div>
    <div class="faq-details">
      <h3 #ques4 (click)="openAnswer(ques4)" class="ques">How does the location of the car affect the car insurance
        premium?
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="plus bi bi-plus" viewBox="0 0 16 16">
          <path
            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
        </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="minus bi bi-dash" viewBox="0 0 16 16">
          <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
        </svg>
      </h3>
      <p id="ans4" class="ans">The cost of a car varies for different locations. Hence, the location of the car has a
        direct impact on the car’s IDV, which in turn impacts the car insurance premium. </p>
    </div>
    <div class="faq-details">
      <h3 #ques5 (click)="openAnswer(ques5)" class="ques">How does a car insurance premium calculator help during policy
        renewal?
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="plus bi bi-plus" viewBox="0 0 16 16">
          <path
            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
        </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="minus bi bi-dash" viewBox="0 0 16 16">
          <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
        </svg>
      </h3>
      <p id="ans5" class="ans">The new car insurance premium calculator is an effective tool during car insurance policy
        renewal.This is because, you cannot just arrive at the insurance quote instantly, as the vehicle insurance
        calculator also helps select a suitable insurance plan that suits your requirements.
      </p>
    </div>
    <div class="faq-details">
      <h3 #ques6 (click)="openAnswer(ques6)" class="ques">How soon should you purchase car insurance after buying a new
        car?
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="plus bi bi-plus" viewBox="0 0 16 16">
          <path
            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
        </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="minus bi bi-dash" viewBox="0 0 16 16">
          <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
        </svg>
      </h3>
      <p id="ans6" class="ans">To drive legally on Indian roads,
        you must have third-party car insurance without fail. Thus, it is recommended to opt for the right insurance
        plan with the help of a vehicle insurance premium calculator on buying a new four-wheeler!</p>
    </div>
    <div class="faq-details">
      <h3 #ques7 (click)="openAnswer(ques7)" class="ques">How can I earn an NCB discount to reduce my car insurance
        renewal
        premium?
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="plus bi bi-plus" viewBox="0 0 16 16">
          <path
            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
        </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="minus bi bi-dash" viewBox="0 0 16 16">
          <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
        </svg>
      </h3>
      <p id="ans7" class="ans">You can easily earn an NCB discount by not making any claims throughout the policy
        period. This way you can avail the No Claim Bonus on your renewal premium. To estimate the premium rate while
        renewing insurance,
        you can make use of the car insurance renewal premium calculator online.</p>
    </div>
    <div class="faq-details">
      <h3 #ques8 (click)="openAnswer(ques8)" class="ques">Why is it important to use a car insurance premium calculator
        during
        policy renewal?
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="plus bi bi-plus" viewBox="0 0 16 16">
          <path
            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
        </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="minus bi bi-dash" viewBox="0 0 16 16">
          <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
        </svg>
      </h3>
      <p id="ans8" class="ans"> The online car insurance premium calculator enables you to lower your insurance premium
        rate, get the best deal in the market and continue securing your vehicle from unfortunate mishaps. Hence, it is
        advised to use the car insurance premium calculator during policy renewal.
      </p>
    </div>
    <div class="faq-details">
      <h3 #ques9 (click)="openAnswer(ques9)" class="ques">How can I combine add-on covers with my car insurance policy?
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="plus bi bi-plus" viewBox="0 0 16 16">
          <path
            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
        </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
          class="minus bi bi-dash" viewBox="0 0 16 16">
          <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
        </svg>
      </h3>
      <p id="ans9" class="ans">You can buy add-on covers for extensive coverage with your comprehensive car insurance
        policy at the time of purchase or renewal. For example, you can opt for add-on covers such as<a
          class="link-desc" target="_blank"
          href="https://www.bajajfinservmarkets.in/insurance/motor-insurance/car-insurance/zero-depreciation-car-insurance.html">
          zero depreciation</a> while using car insurance premium calculators online.
      </p>
    </div>
  </div>
</div>